import { useQuery } from "react-query";

import { IContestTerritoriesListParams } from "~/entity/ContestTerritories/model/schema";

import { useContestTerritories } from "./useContestTerritories";

export const useGetContestTerritories = (
  params: IContestTerritoriesListParams = {},
) => {
  const { getContestTerritories } = useContestTerritories();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getContestTerritories", params],
    queryFn: () => getContestTerritories(params),
  });
  return {
    data: data?.items,
    total: data?.total ?? 0,
    isLoading,
    isError,
    refetch,
  };
};
